import { render, staticRenderFns } from "./UserInvitationData.vue?vue&type=template&id=2b982694&scoped=true"
import script from "./UserInvitationData.vue?vue&type=script&lang=ts"
export * from "./UserInvitationData.vue?vue&type=script&lang=ts"
import style0 from "./UserInvitationData.vue?vue&type=style&index=0&id=2b982694&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b982694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b982694')) {
      api.createRecord('2b982694', component.options)
    } else {
      api.reload('2b982694', component.options)
    }
    module.hot.accept("./UserInvitationData.vue?vue&type=template&id=2b982694&scoped=true", function () {
      api.rerender('2b982694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite/UserInvitationData.vue"
export default component.exports